import React from 'react';
import styles from './BetSlipError.module.scss';

export default function BetSlipError({ type, description }) {
    const isWarning = type === 'warning';
    return (
        <div className={`${styles.error} ${isWarning ? styles.warning : ''}`}>
            <span className={`p-x-3 ${isWarning ? 'icon-exclamation' : 'icon-error'}`} />
            <p className='f-s-12'>{description}</p>
        </div>
    );
}
